import * as React from 'react';
import styled, { keyframes } from 'styled-components';

interface IProps {
  style?: React.CSSProperties;
}

export const LinearLoading = (props: IProps): React.ReactElement => {
  return (
    <Container style={props.style}>
      <Bar1 />
      <Bar2 />
    </Container>
  );
};

const growBar = keyframes`
  0% {
    animation-timing-function: cubic-bezier(0.20503, 0.05705, 0.57661, 0.45397);
    transform: scaleX(0.1);
  }
  19.15% {
    animation-timing-function: cubic-bezier(0.15231, 0.19643, 0.64837, 1.00432);
    transform: scaleX(0.57);
  }
  44.15% {
    animation-timing-function: cubic-bezier(0.25776, -0.00316, 0.21176, 1.38179);
    transform: scaleX(0.91);
  }
  100% {
    transform: scaleX(0.1);
  }
`;

const moveBar = keyframes`
 0% {
    left: -54.88889%;
    animation-timing-function: cubic-bezier(0.15, 0, 0.51506, 0.40968);
  }
  25% {
    left: -17.25%;
    animation-timing-function: cubic-bezier(0.31033, 0.28406, 0.8, 0.73372);
  }
  48.35% {
    left: 29.5%;
    animation-timing-function: cubic-bezier(0.4, 0.62703, 0.6, 0.90203);
  }
  100% {
    left: 117.38889%;
  }
`;
const start = keyframes`
  from {
    max-height: 0;
    opacity: 0;
  }
  to {
    max-height: 20px;
    opacity: 1;
  }
`;

const linearMovement = keyframes`
 0% {
    left: -100%;
  }
  50% {
    left: 100%;
  }
  100% {
    left: 100%;
  }
`;

const Container = styled.div`
  background: #aad1f9;
  position: relative;
  margin: 0 auto;
  overflow: hidden;
  animation: ${start} 0.3s ease-in;
  height: 2px;
  width: 100%;
`;

const Bar = styled.div`
  position: absolute;
  background: #106cc8;
  transition: transform 0.2s linear;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 100%;
`;

const Bar1 = styled(Bar as any)`
  animation: ${linearMovement} 2.5s infinite;
  animation-delay: 0;
`;

const Bar2 = styled(Bar as any)`
  animation: ${growBar} 2.5s infinite, ${moveBar} 2.5s infinite;
`;
